export const NO_INBOUND_TRANSITIONS_TO_STATUS = 'NO_INBOUND_TRANSITIONS_TO_STATUS';
export const NON_UNIQUE_STATUS_NAME = 'NON_UNIQUE_STATUS_NAME';
export const VERSION_CONFLICT = 'VERSION_CONFLICT';
